import { CircularProgress, Container, Stack } from '@mui/material';
import { Suspense } from 'react';

interface AppSuspenseProps {
  children: React.ReactNode;
}

const AppSuspense: React.FC<AppSuspenseProps> = ({ children }) => {
  return (
    <Suspense
      fallback={
        <Container maxWidth={false}>
          <Stack direction="column" alignItems="center" justifyContent="center" height="100vh">
            <CircularProgress />
          </Stack>
        </Container>
      }
    >
      {children}
    </Suspense>
  );
};

export default AppSuspense;
